import React, { useState, useEffect } from 'react';
import useTranslate from '../../Hooks/useTranslate';
import useAPI from '../../api';
import {
  Select,
  MenuItem,
  CircularProgress,
  InputLabel,
  FormControl,
} from '@mui/material';

export const DynamicSelect = ({ field, value, onChange, sx = {} }) => {
  const API = useAPI();
  const translate = useTranslate();
  const [options, setOptions] = useState(field.options || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (field.optionsUrl && (!field.options || field.options.length === 0)) {
      let isMounted = true;
      setLoading(true);

      API.lookupDynamicOptions(
        field.optionsUrl,
        (data) => {
          if (isMounted) {
            setOptions(data);
            setLoading(false);
          }
        },
        (err) => {
          console.error(`Failed to fetch options for ${field.key}`, err);
          setLoading(false);
        }
      );

      return () => {
        isMounted = false;
      };
    }
  }, [field.optionsUrl, field.options, field.key]);

  return (
    <FormControl size="small" sx={sx} margin="normal" fullWidth>
      <InputLabel>{translate(field.label)}</InputLabel>
      <Select
        value={value || ''}
        label={translate(field.label)}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
      >
        {loading ? (
          <MenuItem disabled value="">
            <CircularProgress size={20} sx={{ mr: 2 }} /> {translate('LOADING')}
          </MenuItem>
        ) : options.length === 0 ? (
          <MenuItem disabled value="">
            {translate('NO_OPTIONS_FOUND')}
          </MenuItem>
        ) : (
          options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {translate(opt.label)}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};
